import dynamicUi from './dynamicUi.json'
import ui from './ui.json'

export default {
  language: 'Español',
  ...ui,
  ...dynamicUi
}
